import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AccessPolicyService } from '../services/access-policy.service';
import { permittedLandingPath } from './dashboard-access.guard';

export const rootRedirectGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const accessPolicy = inject(AccessPolicyService);
  const router = inject(Router);

  return authService.ensureSessionRestored()
    .then((restored) => restored
      ? router.createUrlTree([permittedLandingPath(accessPolicy)])
      : router.createUrlTree(['/auth/login']));
};
